module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workbench"
  }, [_c('workbench-toolbar', {
    attrs: {
      "name": _vm.targetName,
      "activated": _vm.activated,
      "metrics": _vm.metrics,
      "loading": _vm.loading,
      "menu": _vm.headerMenu,
      "showGraphs": _vm.showGraphs
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "workbench__top-pane"
  }, [(!_vm.live) ? _c('div', {
    staticClass: "workbench__side-panel",
    class: {
      'is-collapsed': _vm.isCollapsed,
      'is-expanded-view': _vm.isExpandedView
    }
  }, [_c('attribute-panel', {
    attrs: {
      "is-expanded-view": _vm.isExpandedView,
      "is-collapsed": _vm.isCollapsed
    },
    on: {
      "collapse-clicked": _vm.togglePanelCollapse,
      "change-size-click": _vm.togglePanelSize
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "workbench__canvas",
    attrs: {
      "id": "canvas"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "workbench__loader"
  }, [_c('loader-dots')], 1) : _vm._e(), _vm._v(" "), _c('scroll-panel', {
    staticClass: "workbench__canvas-content"
  }, [_vm._t("default")], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "workbench__bottom-pane",
    class: [_vm.sizeClass]
  }, [(_vm.showQuickAddAttributebuttons) ? _c('quick-add-attributes', {
    attrs: {
      "viewOnly": _vm.viewOnly
    }
  }) : _vm._e(), _vm._v(" "), _c('target-definition', {
    attrs: {
      "namespace": "las"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "workbench__bottom-bar"
  }, [_c('bottom-pane-sizer', {
    attrs: {
      "current-size": _vm.currentBottomPaneSize
    },
    on: {
      "new-size": _vm.changeBottomPaneSize
    }
  }), _vm._v(" "), (!_vm.live) ? _c('definition-actions', {
    attrs: {
      "allowDownloadBtn": _vm.allowDownloadBtn
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showRevisionHistoryPanel) ? _c('transparent-control-panel', {
    attrs: {
      "initialPosition": {
        top: 125,
        right: 50
      }
    }
  }, [_c('vuex-revision-history-panel', {
    attrs: {
      "onSetCurrentMove": _vm.setTargetDefinitionFromRevisionHistory
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d7725ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/views/workbenchCanvas/WorkbenchWCanvasSlot.vue
// module id = 1851
// module chunks = 0